import { render, staticRenderFns } from "./helpDocument.vue?vue&type=template&id=c559244e&scoped=true&"
import script from "./helpDocument.vue?vue&type=script&lang=js&"
export * from "./helpDocument.vue?vue&type=script&lang=js&"
import style0 from "./helpDocument.vue?vue&type=style&index=0&id=c559244e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c559244e",
  null
  
)

export default component.exports